import { render, staticRenderFns } from "./RessortTitle.vue?vue&type=template&id=217ac9f0&scoped=true&"
import script from "./RessortTitle.vue?vue&type=script&lang=js&"
export * from "./RessortTitle.vue?vue&type=script&lang=js&"
import style0 from "./RessortTitle.vue?vue&type=style&index=0&id=217ac9f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217ac9f0",
  null
  
)

export default component.exports